<div id="company-register-tab" class="company-register-tab">
    <div class="filter">
        <div class="form-wrap checkbox-view half-field">
            <mat-checkbox class="checked61" [checked]="checkBoxDefaultValues" (change)="ChangeSelection('A',$event)">Agenda</mat-checkbox>
        </div>
        <div class="form-wrap checkbox-view half-field">      
            <mat-checkbox class="checked61" [checked]="checkBoxDefaultValues" (change)="ChangeSelection('V',$event)" *ngIf="hasVisitaViewAndEditPermission">Visitas de empresa</mat-checkbox>
        </div>
        <div class="form-wrap checkbox-view half-field">
            <mat-checkbox class="checked61" [checked]="checkBoxDefaultValues" (change)="ChangeSelection('M',$event)">Reuniones con SME</mat-checkbox>
        </div>
        <div class="form-wrap checkbox-view half-field">
            <mat-checkbox class="checked61" [checked]="checkBoxDefaultValues" (change)="ChangeSelection('R',$event)">Revisiones</mat-checkbox>
        </div>
    </div>
    <h2>
        Registro
        <button class="adder" type="button" mat-button [matMenuTriggerFor]="menusub">+</button>
        <mat-menu #menusub="matMenu">
            <button class="com-reg-btn" mat-menu-item (click)="AddOrEdit('A',null)">Agenda</button>
            <button class="com-reg-btn" mat-menu-item (click)="AddOrEdit('V',null)">Visita de empresa</button>
            <button class="com-reg-btn" mat-menu-item (click)="AddOrEdit('M',null)">Reunión con SME</button>
            <button class="com-reg-btn" mat-menu-item (click)="AddOrEdit('R',null)">Revisión</button>
        </mat-menu>
    </h2>
    <div class="agenda-loop-wrapper">
        <div class="agenda-loop" *ngFor="let register of registerList; let i = index">
            <p>
                <span>{{register.fecha | date: 'dd/MM/yyyy'}}</span>
                <span>-</span>
                <span>{{register.titulo}} </span>
                <span *ngIf="register.asunto != null && register.asunto !=''">-</span>
                <span>{{register.asunto}} </span>
                <span>{{register.autor}}
                    <button class="more" type="button" mat-button [matMenuTriggerFor]="menumore" *ngIf='register.tipo!="V" || hasVisitaViewAndEditPermission || hasVisitaDeletePermission '>
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menumore="matMenu">
                        <button mat-menu-item (click)="AddOrEdit(register.tipo,register)" *ngIf='register.tipo!="V" || hasVisitaViewAndEditPermission'>
                            <mat-icon>edit</mat-icon>Editar
                        </button>
                        <button mat-menu-item (click)="DeleteRegistro(i,register.id,register.tipo)" *ngIf='register.tipo!="V" || hasVisitaDeletePermission'>
                            <mat-icon>delete_forever</mat-icon>Eliminar
                        </button>
                    </mat-menu>
                </span>
            </p>
            <br>
            <span *ngIf="register.asistentes != null">{{register.asistentesConcat}}</span>
            <br>
            <br>
            <span>{{register.texto}} </span>
        </div>
    </div>
</div>